import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import { AuthProvider } from './context/AuthProvider';
import { ThemeProvider } from './context/ThemeContext';
import { SearchTermProvider } from './context/SearchTermContext';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
    <BrowserRouter>
    <ThemeProvider>
    <SearchTermProvider>
      <App />
    </SearchTermProvider>
    </ThemeProvider>
    </BrowserRouter>
    </AuthProvider>
    
  </React.StrictMode>
);
